import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=7a2b6835&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=7a2b6835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2b6835",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a2b6835')) {
      api.createRecord('7a2b6835', component.options)
    } else {
      api.reload('7a2b6835', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=7a2b6835&scoped=true&", function () {
      api.rerender('7a2b6835', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Profile.vue"
export default component.exports